import { UserCustomization } from '../interfaces/user-customization.interface';

export class Company{
    _id?: string;
    name?: string;
    legalName?: string;
    vatNumber?: string;
    accountManager?: string;
    parentCompany?: string;
    addressShipping?: string;
    addressInvoicing?: string;
    isDistributor?: boolean;
    defaultBillingTemplateId?: string;
    customization?: UserCustomization;
    updatedAt?: Date;
    createdAt?: Date;
  }